import * as _ from 'lodash'
// import { Api } from '@/service';
import codes from '@/codes'

//restful api
import { detect, system } from '@/service/api/wsfinder'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv : false,
});

const i18n_fields = {
  EN: [
    { key: 'created_at', label: 'Date', sortable: false, thStyle: 'width: 10%' },
    { key: 'group', label: 'Company', sortable: false, thStyle: 'width: 20%' },
    { key: 'agent', label: 'Agent', sortable: false, thStyle: 'width: 15%' },
    { key: 'category', label: 'Rule', sortable: false, thStyle: 'width: 10%' },
    { key: 'path', label: 'Path', sortable: false, thStyle: 'width: 10%' },
  ],
  KO: [
    { key: 'created_at', label: '날짜', sortable: false, thStyle: 'width: 10%' },
    { key: 'group', label: '회사명', sortable: false, thStyle: 'width: 20%' },
    { key: 'agent', label: '에이전트', sortable: false, thStyle: 'width: 15%' },
    { key: 'category', label: '룰', sortable: false, thStyle: 'width: 10%' },
    { key: 'path', label: '경로', sortable: false, thStyle: 'width: 10%' },
  ]
}

export default {
	data: () => {
		return {
      codes,
      pattern : undefined,
      show: true,
      sync : { interval : 15, stop : false, th : undefined },
      so : default_opt(),
    }
  },
  computed: {
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    },
    f_detect() {
      return i18n_fields[this.i18n];
    }
  },
	methods: {
    getPattern() {
      // recent system pattern
      // let so = Object.assign({}, this.so, { target : 'wsfinder.pattern', cmd : 'list', offset : 0, limit : 1, body : {
      //   columns : ["type", "created_at"], sort : [{ name : 'id', op : 'desc' }],
      //   // and : [{ name : 'is_alive', op :  '=', value : true }] // option
      // } })
      // Api.Manager(so).then(rs => { this.pattern = rs.body ? rs.body[0] : null; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));

      let so = Object.assign({}, this.so, { offset : 0, limit : 1, body : {
        columns : ["type", "created_at"], sort : [{ name : 'id', op : 'desc' }],
        // and : [{ name : 'is_alive', op :  '=', value : true }] // option
      } })
      system.listSys(so).then(rs => { this.pattern = rs.body ? rs.body[0] : null; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    refresh() {
      if((!this.sync.stop || this.so.adv) && this.$refs._list) {
        this.$refs._list.refresh(); console.log('wsfinder log refresh', new Date());
      }
    },
    reset() { this.so = default_opt(); this.so.opt.from = ''; this.so.opt.to = ''; this.refresh(); },
    load(ctx = {}) {
      let so = {
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        // target : 'wsfinder.detect',
        // cmd : 'list',
        offset : this.so.currentPage-1 || 0,
        limit :  Number(this.so.perPage),
        body: {
          and : [],
          sort : [ { name : "id", op : "desc" } ]
        }
      }
      so.offset = so.offset * so.limit;

      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }

      //일부 키워드 검색
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }

      // return Api.Manager(so).then(rs => {
      return detect.listDetect(so).then(rs => {
        this.so.totalRows = rs.total;
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    pause: function() { this.sync.stop = !this.sync.stop; this.refresh(); if(this.sync.stop) { this.so.adv = false; } },
	},
  created: function() { console.log('WSFinder', 'dashboard.vue', 'created'); },
  destroyed: function() { console.log('WSFinder', 'dashboard.vue', 'destroyed'); clearTimeout(this.sync.th); this.sync.th = undefined; },
  mounted: function() { console.log('WSFinder', 'dashboard.vue', 'mounted'); this.getPattern() },
}